import api from './api';

type RingBufferHistoryArgs = {
  entityId: string;
};

export type RingBufferRequestType =
  | 'historical'
  | 'upcoming'
  | 'historicalAndUpcoming';

export type RingBufferDates = {
  fromDate: string;
  toDate: string;
  requestedDate: string;
};

type EmptyRingBufferArgs = RingBufferDates &
  RingBufferHistoryArgs & {
    requestType: RingBufferRequestType;
  };

export type EmptyRingBufferResponse = {
  error?: string;
  responseReceivedDate: string;
};

export type RingBuffer = {
  userName: string;
  requestType: string;
  result?: 'Acknowledged' | 'Failed' | null;
  responseReceivedDate?: string | null;
} & RingBufferDates;

const EMPTY_RING_BUFFER_URL = '/graphs/stategraph/emptyRingBuffer';
const RING_BUFFER_HISTORY_URL = '/graphs/stategraph/ringBufferHistory';

export const ringBufferApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRingBufferHistory: build.query<RingBuffer[], RingBufferHistoryArgs>({
      query: (params) => ({
        url: RING_BUFFER_HISTORY_URL,
        params,
      }),
      providesTags: ['RingBufferHistory'],
    }),

    emptyRingBuffer: build.mutation<
      EmptyRingBufferResponse,
      EmptyRingBufferArgs
    >({
      query: (params) => ({
        url: EMPTY_RING_BUFFER_URL,
        method: 'POST',
        params,
      }),
      invalidatesTags: ['RingBufferHistory'],
    }),
  }),
});

export const { useEmptyRingBufferMutation, useGetRingBufferHistoryQuery } =
  ringBufferApi;
